import { faCircleArrowLeft, faArrowAltCircleRight } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Card, CardActionArea, CardContent, CardHeader, IconButton, Typography, makeStyles } from '@material-ui/core';
import { PageHeader } from 'pages/CustomerBookingCreate/components/PageHeader';

import { BOOKINGRECIPIENT_OTHER, BOOKINGRECIPIENT_SELF, BOOKINGRECIPIENT_SELF_AND_OTHERS, STEP_LOCATION, STEP_RECIPIENT } from 'pages/CustomerBookingCreate/constants';
import { bookingState, stepState } from 'pages/CustomerBookingCreate/state';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import { useExternalLinkProcessor } from './ExternalLinkProcessor';
import { useTrackEvent } from 'util/trackEvent';
import useCustomModal from 'components/CustomConfirm';
import CustomConfirmDialog from 'components/CustomConfirm/CustomConfirmDialog';
import medPhone from 'assets/medphone.png'

const useStyles = makeStyles(theme => ({
  cards: {
    "&>*": {
      marginBottom: theme.spacing(6)
    }
  }
}));
const RecipientScreen = ({ }) => {
  const classes = useStyles()
  const [booking, setBooking] = useRecoilState(bookingState);
  const [step, setStep] = useRecoilState(stepState);
  const history = useHistory()
  const trackEvent = useTrackEvent()

  const confirm = useCustomModal()

  const viewResultPopup = useCallback(
    () => {
      confirm(props => (
        <CustomConfirmDialog {...props}
          preHeader={<img src={medPhone} style={{ maxHeight: 200 }} />}
          title="How do I view my results?"
          description="After the service is complete, you’ll need to install the zennya app to view and download medical records and lab results"
          confirmationText='Continue'
          
          onCancel={() => { 
            trackEvent('View results dialog - cancel', { dialog: ['viewResultPopup'] })
            props.onClose() 
          }}
          onConfirm={async () => {
            trackEvent('View results dialog - continue', { dialog: ['viewResultPopup'] })
            setBooking({
              ...booking,
              recipient: BOOKINGRECIPIENT_SELF
            })
            setStep(STEP_LOCATION)
            history.replace(STEP_LOCATION, { internal: true })
            props.onClose()
          }}
        />
      ))
    },
    [confirm, trackEvent],
  );

  return (
    <>
      <PageHeader
        backStep={null}
        currentStep={STEP_RECIPIENT}
        title={"Who is this for?"}
        subheader={"You can book for yourself or for others."}
        loading={false}
      >

        <CardContent className={classes.cards}>
          <Card>
            <CardActionArea onClick={() => {
              trackEvent('Recipient - Me')
              viewResultPopup()
            }}
            >
              <CardHeader
                title="Me"
                action={
                  <IconButton
                    color='primary'
                  >
                    <FontAwesomeIcon icon={faArrowAltCircleRight} />
                  </IconButton>
                }
              />
            </CardActionArea>
          </Card>
          <Card>
            <CardActionArea onClick={() => {
              trackEvent('Recipient - Me and Others')
              history.replace('/createbooking/zennyaapp', {defer: true})
            }}>
              <CardHeader
                title="Me and Others"
                action={
                  <IconButton color='primary'>
                    <FontAwesomeIcon icon={faArrowAltCircleRight} />
                  </IconButton>
                }
              />
            </CardActionArea>
          </Card>
          <Card>
            <CardActionArea onClick={() => {
              trackEvent('Recipient - Others')
              history.replace('/createbooking/zennyaapp', {defer: true})
            }}>
              <CardHeader
                title="Others"
                action={
                  <IconButton
                    color='primary'
                  >
                    <FontAwesomeIcon icon={faArrowAltCircleRight} />
                  </IconButton>
                }
              />
            </CardActionArea>
          </Card>
        </CardContent>
      </PageHeader>
    </>
  )
}

export { RecipientScreen }